import { Search, Send, Users, PhoneCall } from "lucide-react";
import { PageHero } from "./About";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const STEPS = [
  { icon: Search, title: "Browse available properties", desc: "Search homes for sale and to let from a range of trusted property partners. Filter by location, price, type and more." },
  { icon: Send, title: "Submit an enquiry", desc: "Found something you like? Send a quick, no-obligation enquiry directly from the property page." },
  { icon: Users, title: "Your enquiry is referred", desc: "We pass your details securely to the relevant estate agent or letting agency handling the property." },
  { icon: PhoneCall, title: "The agency contacts you", desc: "The property partner gets in touch directly to arrange a viewing and answer your questions." },
];

export default function HowItWorks() {
  return (
    <div>
      <PageHero kicker="How it works" title="From browsing to viewing in four simple steps" subtitle="Homio makes it easy to enquire about properties and be introduced to the right agency." />
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 space-y-8">
        {STEPS.map((s, i) => (
          <div key={i} className="flex gap-6 items-start bg-white rounded-2xl border border-border p-6" data-testid={`hiw-step-${i + 1}`}>
            <div className="w-14 h-14 rounded-full bg-[#C81D35] text-white flex items-center justify-center text-xl font-bold shrink-0">{i + 1}</div>
            <div>
              <div className="flex items-center gap-3"><s.icon className="w-6 h-6 text-[#C5A059]" /><h3 className="font-display text-xl font-bold text-[#111827]">{s.title}</h3></div>
              <p className="mt-2 text-[#111827]/70">{s.desc}</p>
            </div>
          </div>
        ))}
        <div className="rounded-2xl bg-muted p-6 text-sm text-muted-foreground">
          Please note: submitting an enquiry permits Homio to share the necessary details with the relevant property partner. Marketing consent is separate and always optional.
        </div>
        <div className="text-center pt-4"><Link to="/properties"><Button className="rounded-full bg-[#C81D35] hover:bg-[#a5162b] px-8 h-12">Start your search</Button></Link></div>
      </div>
    </div>
  );
}
